import React, { useState } from "react";

import { useForm } from "react-hook-form";

import { ReactComponent as HideTextSvg } from '../assets/hide_text.svg';
import { ReactComponent as ShowTextSvg } from '../assets/show_text.svg';

import { useHistory, useNavigate, Navigate } from 'react-router-dom';

import ReactSelect, { components } from "react-select";

import {getAuth, createUserWithEmailAndPassword, sendEmailVerification, applyActionCode} from 'firebase/auth';
import { logoutUser, config } from '../firebase';



export default function ConfirmEmail({user}) {

    const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();

    const navigate = useNavigate();

    const [isShowPassword, setShowPassword] = useState(false);
    const toggle = () => {
        setShowPassword(!isShowPassword);
    };

    const [signup_error, setError] = useState('');

	const resend = event => {

 		sendEmailVerification(user).then(() => {

 		}).catch((err) => {console.log(err.message)})

	}

	console.log(user);

	const queryParameters = new URLSearchParams(window.location.search)

	const mode = queryParameters.get("mode");
	const code = queryParameters.get("oobCode");
	const apiKey = queryParameters.get("apiKey");

	if (mode == 'verifyEmail' && apiKey == config.apiKey)
	{
		const auth = getAuth();
		applyActionCode (auth, code).then((resp) => {

			window.location.reload();

		}).catch((error) => {

			window.location.reload();
		});
	}


    return (


		<form className="form-auth confirm-email">

			<a href="/" className="logo"> </a>

			<div className="note">
				You need to verify your email address: <br />{user.email}
			</div>


			<div className="error">{signup_error}</div>


			<div className="actions">

				<div className="signup-link" onClick={resend}>
					<span>Resend verification code </span>
				</div>


				<div className="signup-link"  onClick={logoutUser}>
					<span>Sign up with a different email</span>
				</div>

			</div>

		</form>

	);

}
